import React from 'react';

const LinkedlnIconImage = () => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.92785 15.875H3.38489V7.69922H5.92785V15.875ZM4.67004 6.57812C4.269 6.57812 3.92265 6.43229 3.63098 6.14062C3.33931 5.84895 3.19348 5.5026 3.19348 5.10156C3.19348 4.70052 3.33931 4.35417 3.63098 4.0625C3.92265 3.77083 4.269 3.625 4.67004 3.625C5.07108 3.625 5.41743 3.77083 5.7091 4.0625C6.00077 4.35417 6.1466 4.70052 6.1466 5.10156C6.1466 5.5026 6.00077 5.84895 5.7091 6.14062C5.41743 6.43229 5.07108 6.57812 4.67004 6.57812ZM15.4435 15.875H12.9005V11.8828C12.9005 11.2266 12.8458 10.7526 12.7364 10.4609C12.5359 9.96874 12.144 9.72265 11.5607 9.72265C10.9773 9.72265 10.5672 9.9414 10.3302 10.3789C10.1479 10.707 10.0568 11.1901 10.0568 11.8281V15.875H7.54114V7.69922H9.97473V8.82031H10.0021C10.1844 8.45573 10.476 8.15495 10.8771 7.91797C11.3146 7.6263 11.825 7.48047 12.4083 7.48047C13.5932 7.48047 14.4226 7.85417 14.8966 8.60156C15.2612 9.20312 15.4435 10.1328 15.4435 11.3906V15.875Z"
      fill="black"
      fillOpacity="0.6"
    />
  </svg>
);

export default LinkedlnIconImage;
